const adxInit = () => {
  // Ensure we can interact with the GPT command array.
  window.googletag = window.googletag || { cmd: [] }

  // Prepare GPT to display ads.
  googletag.cmd.push(() => {
    // Disable initial load, to precisely control when ads are requested.
    googletag.pubads().disableInitialLoad()
    // Enable SRA and services.
    googletag.pubads().enableSingleRequest()
    // googletag.pubads().collapseEmptyDivs()
    googletag.enableServices()

    // 广告已请求
    googletag.pubads().addEventListener('slotRequested', event => {
      // 数据统计-广告请求
      window.dataKule.push('track', 'ad', 'request', {
        type: 0
      })
    })

    // 广告已展示
    googletag.pubads().addEventListener('slotOnload', event => {
      // 数据统计-广告请求
      window.dataKule.push('track', 'ad', 'show', {
        type: 0
      })
    })
  })
}

export default adxInit
